import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

import { Container } from '@ttstr/components';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Container className="text-left">
      <Row>
        <Col md={{ size: 4, offset: 0 }}>
          {/* <h5>Links</h5>
          <ul className="list-unstyled">
            <li>
              <a href="https://www.instagram.com/XXX">Instagram</a>
            </li>
            <li>
              <a href="https://www.tiktok.com/@XXX">TikTok</a>
            </li>
          </ul> */}
          <h5>{t(`FOOTER.HEAD1`)}</h5>
          <ul className="list-unstyled">
            <li>
              <Link to="/faq">Häufig gestellte Fragen / FAQ</Link>
            </li>
            <li>
              <Link to="/imprint">{t(`IMPRINT.TITLE`)}</Link>
            </li>
            <li>
              <Link to="/privacy">{t(`PRIVACY.TITLE`)}</Link>
            </li>
            <li>
              <Link to="/terms">{t(`TERMS_AND_CONDITIONS.TITLE`)}</Link>
            </li>
            <li>
              <Link to="/b2b">Händleranfragen (B2B)</Link>
            </li>
          </ul>
          <h5>Socials</h5>
          <ul className="list-unstyled">
            <li>
              <a href="https://www.instagram.com/ottmanns_">Instagram</a>
            </li>
          </ul>
        </Col>
        {/* <Col md="4" className="text-sm-right"></Col> */}
        <Col md="4">
          <h5>Kontakt</h5>
          <p>Du hast Fragen zu deiner Bestellung? Unser Support hilft dir gerne weiter:</p>
          <p>
            <strong>Ottmanns Support</strong>
            <br />
            <a href="mailto:info@ottmanns.de">info@ottmanns.de</a>
            <br />
            <a href="https://support.tickettoaster.de/RMA">{'Bestellung widerrufen'}</a>
          </p>
        </Col>
        <Col md="4">
          <h5>Hinweis</h5>
          <p>
            Die CBD-Produkte sind weder Arzneimittel im Sinne von §2 des Arzneimittelgesetzes, noch Medizinprodukte im
            Sinne von §3 des Medizinproduktegesetzes.{' '}
            <strong>
              Bei gesundheitlichen Problemen oder Fragen zur Verwendung zu diesem Artikel wende dich bitte an einen Arzt
              oder Apotheker.
            </strong>
          </p>
        </Col>
        {/* eslint-enable react/jsx-no-literals */}
      </Row>
    </Container>
  );
};

export default React.memo(Footer);
